import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { NewPageService } from '../../new-page.service';

interface DirectorData {
  name: string;
  message: string;
  photo: string;
  school: string;
  backgroundColor: string;
}

@Component({
  selector: 'app-director-desk',
  templateUrl: './director-desk.component.html',
  styleUrls: ['./director-desk.component.scss'],
  standalone: false,
})
export class DirectorDeskComponent implements OnInit {
  @Input() school: any = {};
  ngOnInit(): void {
    // this.setProfilePicture();
  }

  // setProfilePicture(): void {
  //   if (this.school?.profilePicture === undefined) {
  //     this.school.profilePicture = '"../../assets/images/directorsImage.png"';
  //   }
  // }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['school'] && changes['school'].currentValue) {
    //   this.setProfilePicture();
    // }
  }
}
